import { useContext, useState } from 'react';
import { UserContext } from 'contexts/UserContext';
import Diet from 'components/MoreMenuElements/Diet';
import InvoiceAddress from 'components/InvoiceAddresses';
import Languages from 'components/MoreMenuElements/Languages';
import OpenOrders from 'components/MoreMenuElements/OpenOrders';
import OrderHistory from 'components/MoreMenuElements/OrderHistory';
import Referal from 'components/MoreMenuElements/Referal';
import Profile from 'components/MoreMenuElements/Profile';
import MoreMenuModal from 'components/Modals/MoreMenuModal';
import { useNavigate } from 'react-router-dom';
import ListElement from './ListElement';
import { AppParamsContext } from 'contexts/AppParamsContext';
import DeliveryAddress from 'components/DeliveryAddress';
import V2ListingAppMenu from 'views/MoreMenu/V2ListingAppMenu';

export default function MoreMenuList({ onSelect }) {
  const { appParams } = useContext(AppParamsContext);

  const navigate = useNavigate();
  const { isVipBrand, userLoggedIn } = useContext(UserContext);

  const [modalContent, setModalContent] = useState(false);

  const handleListBoxClick = (key) => {
    switch (key) {
      case 'profile':
        setModalContent(<Profile />);
        break;
      case 'invoiceAddress':
        setModalContent(<InvoiceAddress />);
        break;
      case 'deliveryAddress':
        setModalContent(<DeliveryAddress />);
        break;
      case 'orderHistory':
        setModalContent(<OrderHistory onSelect={onSelect} />);
        break;
      case 'openOrders':
        setModalContent(<OpenOrders />);
        break;
      case 'vip':
        navigate('/vip');
        if (typeof onSelect === 'function') onSelect();
        break;
      case 'coupons':
        navigate('/coupons/all');
        if (typeof onSelect === 'function') onSelect();
        break;
      case 'newsfeed':
        navigate('/newsfeed/all');
        if (typeof onSelect === 'function') onSelect();
        break;
      case 'languages':
        setModalContent(<Languages close={() => setModalContent(false)} />);
        break;
      case 'diet':
        setModalContent(<Diet />);
        break;
      case 'referal':
        setModalContent(<Referal />);
        break;
      case 'locations':
        navigate('/locations/all');
        if (typeof onSelect === 'function') onSelect();
        break;
      case 'morelocations':
        navigate('/locations/all');
        if (typeof onSelect === 'function') onSelect();
        break;
      case 'moreOrder':
        navigate('/order');
        if (typeof onSelect === 'function') onSelect();
        break;
      case 'lastOrder':
        navigate('/lastorder');
        if (typeof onSelect === 'function') onSelect();
        break;
      case 'mapLayouts':
        navigate('/map-layouts/all');
        if (typeof onSelect === 'function') onSelect();
        break;
      case 'achievements':
        navigate('/achievements');
        if (typeof onSelect === 'function') onSelect();
        break;
      case 'privacyLink':
        window.open(appParams?.others?.privacyLink || 'https://download.okeoke.io/docs/policy.pdf');
        if (typeof onSelect === 'function') onSelect();

        break;
      default:
    }
  };
  const moreMenuElements = [
    {
      key: 'languages',
      iconName: 'multiLang',
      canAccessWithoutLogin: true,
      canAccessWithoutVip: true,
    },
    // {
    //   key: 'locations',
    //   iconName: 'multiLang',
    //   canAccessWithoutLogin: true,
    //   canAccessWithoutVip: true,
    // },
    {
      key: 'morelocations',
      iconName: 'multiLang',
      canAccessWithoutLogin: true,
      canAccessWithoutVip: true,
    },
    {
      key: 'mapLayouts',
      iconName: 'multiLang',
      canAccessWithoutLogin: true,
      canAccessWithoutVip: true,
    },
    {
      key: 'moreOrder',
      iconName: 'setTag',
      canAccessWithoutLogin: true,
      canAccessWithoutVip: true,
    },
    {
      key: 'profile',
      iconName: 'setUser',
      canAccessWithoutLogin: false,
      canAccessWithoutVip: true,
    },
    {
      key: 'referal',
      iconName: 'setUser',
      canAccessWithoutLogin: false,
      canAccessWithoutVip: true,
    },
    {
      key: 'newsfeed',
      iconName: 'setUser',
      canAccessWithoutLogin: false,
      canAccessWithoutVip: true,
    },
    {
      key: 'invoiceAddress',
      iconName: 'invoice',
      canAccessWithoutLogin: false,
      canAccessWithoutVip: true,
    },
    {
      key: 'deliveryAddress',
      iconName: 'invoice',
      canAccessWithoutLogin: false,
      canAccessWithoutVip: true,
    },
    {
      key: 'orderHistory',
      iconName: 'orderHistory',
      canAccessWithoutLogin: false,
      canAccessWithoutVip: true,
    },
    {
      key: 'openOrders',
      iconName: 'orders',
      canAccessWithoutLogin: false,
      canAccessWithoutVip: true,
    },
    {
      key: 'lastOrder',
      iconName: 'orders',
      canAccessWithoutLogin: false,
      canAccessWithoutVip: true,
    },
    {
      key: 'diet',
      iconName: 'diet',
      canAccessWithoutLogin: false,
      canAccessWithoutVip: false,
    },
    {
      key: 'vip',
      iconName: 'setCoupon',
      canAccessWithoutLogin: false,
      canAccessWithoutVip: false,
    },
    {
      key: 'coupons',
      iconName: 'setCoupon',
      canAccessWithoutLogin: false,
      canAccessWithoutVip: false,
    },
    {
      key: 'achievements',
      iconName: 'setCoupon',
      canAccessWithoutLogin: false,
      canAccessWithoutVip: false,
    },
    {
      key: 'privacyLink',
      iconName: 'invoice',
      canAccessWithoutLogin: true,
      canAccessWithoutVip: true,
    },
  ];

  return (
    <>
      <MoreMenuModal isOpen={modalContent} setIsOpen={setModalContent} content={modalContent} />
      {appParams?.navigation?.appMenuSettings?.enabled !== true &&
        moreMenuElements
          // ?.sort((a, b) => appParams?.styles?.moreMenu?.elementsOrder?.[a.key] - appParams?.styles?.moreMenu?.elementsOrder?.[b.key])
          ?.map((element) => {
            if (!element.canAccessWithoutLogin && !userLoggedIn) return null;
            if (!element.canAccessWithoutVip && !isVipBrand) return null;
            return <ListElement key={element.key} name={element.key} iconName={element.iconName} onClick={handleListBoxClick} />;
          })}

      {appParams?.navigation?.appMenuSettings?.enabled === true && <V2ListingAppMenu onSelect={handleListBoxClick} />}
    </>
  );
}
